"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=marketplace-config.type.js.map